import script from "./RecordDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RecordDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./RecordDetailModal.vue?vue&type=style&index=0&id=303777e8&scoped=true&lang=scss"
import "./RecordDetailModal.vue?vue&type=style&index=1&id=303777e8&lang=scss"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-303777e8"]])

export default __exports__